export default __webpack_public_path__ + "9e0ecd0ffb4eeb773fe1ad3402ccfcb8.png";